import { WHITE } from '@/constants/colors';
import { SxProps, Theme } from '@mui/material';

export const CALENDAR_RAIL_WIDTH = { xs: 260, xl: 340 };

export const calendarRailColumnSx: SxProps<Theme> = {
    flexShrink: 0,
    alignSelf: 'flex-start',
    position: 'sticky',
    top: 0,
    height: '100%',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: WHITE,
    width: CALENDAR_RAIL_WIDTH,
    overflowX: 'hidden',
    borderLeft: '1px solid',
    borderColor: 'divider',
};
